<template>
    <tr>
        <td class="align-middle">{{index + 1}}</td>
        <td>
            <div class="form-group">
                <div class="input-group">
                    <div class="input-group-prepend w-100">
                        <label class="input-group-text border-right-0">
                            <i class="fas fa-user"></i>
                        </label>
                        <multiselect v-model="selectedStaff" :options="staffsList" label="name" track-by="staffID" :searchable="true" :show-labels="false" openDirection="below" @select="selectStaff"></multiselect>
                    </div>
                </div>
            </div>
        </td>
        <td class="align-middle">
            <input class="form-control" type="number" placeholder="Effort" step="any" v-model="effort" :min="0" @change="updatePercentage"/>
        </td>
        <td class="align-middle">
            <div class="row">
                <div class="col-9 pr-0">
                    <input class="form-control" type="number" step="any" placeholder="Effort %" v-model="percentage" :min="0" @change="updateEffort"/>
                </div>
                <div class="col-3 d-flex align-items-center"><i class="fas fa-percent"></i></div>
            </div>
        </td>
        <td class="align-middle">
            <input type="number" class="form-control" placeholder="Fee" v-model="fee" :min="0"/>
        </td>
    </tr>
</template>
<script>
import _ from 'lodash';
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
import {calculateEffortPercentage} from './../../../../assets/js/dashboard/salonReport/salonReport'

export default {
    name: 'commissionItemEdit',
    props: {
        price: { type: Number },
        staffsList: { type: Array },
        staff: { type: Object },
        index: { type: Number }
    },
    data(){
        return{
            selectedStaff: {}, effort: 0, percentage: 0, fee: 0
        }
    },
    methods:{
        selectStaff(item){
            this.selectedStaff = item;
        },
        updatePercentage(e){
            this.effort = e.target.value
            this.percentage = formatPrice(calculateEffortPercentage(this.price, this.effort))
        },
        updateEffort(e){
            this.percentage = e.target.value
            this.effort = formatPrice((this.percentage/100) * this.price);
        },
        submitStaffItems(){
            var data = {
                staffID: this.selectedStaff.staffID,
                effort: this.effort,
                fee: this.fee
            }
            return data;
        }
    },
    mounted(){
        let $vm = this;
        $vm.selectedStaff = $vm.staff;
        $vm.effort = $vm.staff.effort;
        $vm.percentage = formatPrice(calculateEffortPercentage($vm.price, $vm.effort))
        $vm.fee = $vm.staff.fee;
    },
}

</script>
<style scoped>
.small-select > div{
    max-height: 5em !important;
}
</style>